import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function NotFoundPage() {
  return (
    <>
      <SEOHead
        title="404 - Siden blev ikke fundet | Gribskovsmeden ApS"
        description="Den side du leder efter findes desværre ikke. Gå tilbage til forsiden eller find vores ydelser her."
      />

      <div className="min-h-[65vh] flex items-center justify-center py-20 bg-stone-50 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-10 rounded-2xl shadow-sm border border-stone-200">
          <div className="w-16 h-16 bg-amber-50 text-amber-600 rounded-2xl flex items-center justify-center mx-auto text-3xl font-extrabold">
            404
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-stone-900 tracking-tight">
              Siden blev ikke fundet
            </h1>
            <p className="text-stone-600 text-sm leading-relaxed">
              Vi kunne desværre ikke finde siden, du ledte efter. Den er muligvis blevet flyttet eller slettet.
            </p>
          </div>

          <div className="pt-4 flex flex-col gap-2.5">
            <Link
              to="/"
              className="w-full py-3 bg-stone-900 hover:bg-stone-800 text-white font-bold text-sm rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-house text-xs" aria-hidden="true"></i>
              <span>Gå til forsiden</span>
            </Link>
            <Link
              to="/kontakt"
              className="w-full py-3 bg-stone-100 hover:bg-stone-200 text-stone-800 font-semibold text-sm rounded-lg transition-colors"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
